import React from 'react';
import BrivaWebsite from './BrivaWebsite';

function App() {
  return <BrivaWebsite />;
}

export default App;
